import Vue from 'vue'

export default new Vue({
    methods: {
        open (opts) {
            return new Promise((resolve, reject) => {
                this.$once('modal-return', (name, modal) => {
                    if (name === 'error') return reject()
                    resolve({name, modal})
                })
                this.$emit('modal-open', opts)
            })
        }
    }
})